import {Component, OnInit} from '@angular/core';
import {DocumentModel} from '../../../models/document.model';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../../services/new-document.service';
import {StateManagerService} from '../../../services/state-manager.service';
import {CollectionsNames} from '../../../definitions/collections-names';
import {TestConnectionService} from '../../../services/test-connection.service';
import {RefreshdatabaseService} from '../../../services/database/refreshdatabase.service';
import {GeneralService} from '../../../services/general.service';
import {SiteModel} from '../../../models/site.model';
import {DetaillineDTOModel} from '../../../models/detaillineDTO.model';
import {DocumentTypes} from '../../../definitions/document-types';
import {ValidateDocumentService} from '../../../services/validate-document.service';
import {GeneralSaveDocumentService} from '../../../services/general-save-document.service';
import {ScannedTodayService} from '../../../services/scanned-today.service';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../../definitions/barcode-options';
import {PersistScannedBarcodesService} from '../../../services/persist-scanned-barcodes.service';
import {FindEquipmentPriceService} from '../../../services/find-equipment-price.service';
import {RefreshLiveDetailLinesService} from '../../../services/refresh-live-detail-lines.service';

@Component({
    selector: 'app-buffered-stock-conciliation',
    templateUrl: './buffered-stock-conciliation.component.html',
    styleUrls: ['./buffered-stock-conciliation.component.scss'],
})
export class BufferedStockConciliationComponent implements OnInit {

    documentTemp: DocumentModel;
    loading: any;
    manualInput: string;

    constructor(public modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private testConnectionService: TestConnectionService,
                private refreshdatabaseService: RefreshdatabaseService,
                private generalService: GeneralService,
                private loadingController: LoadingController,
                private docTypes: DocumentTypes,
                private validateDoc: ValidateDocumentService,
                private generalSaveDocument: GeneralSaveDocumentService,
                private scannedTodayService: ScannedTodayService,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private persistScannedBarcodesService: PersistScannedBarcodesService,
                private alertController: AlertController,
                private findEquipmentPriceService: FindEquipmentPriceService,
                private refreshLiveDetailLinesService: RefreshLiveDetailLinesService) {
    }

    async ngOnInit() {
        this.documentTemp = this.newDocumentService.genNewDocument();
        this.documentTemp.documentType = this.docTypes.STOCKING;
        await this.refreshLiveDetailLinesService.refreshLiveDetailLines();
    }

    listenCustomer(event) {
        this.documentTemp.customer = event;
        this.documentTemp.site = new SiteModel();
        this.documentTemp.detailLines = new Array<DetaillineDTOModel>();
    }

    listenSite(event: any) {
        console.log(event);
        this.documentTemp.site = event;
        this.loadLiveLinesForWard();
    }

    cancelCheck() {
        this.modalController.dismiss();
    }

    async scanItem() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
    }

    async handleScanResult(barcode) {
        console.log('Scan Result');
        console.log(barcode);
        this.manualInput = null;
        const equipment = this.documentTemp.detailLines.find(line => {
            if (line.barcode === barcode) {
                this.persistScannedBarcodesService.persistBarcode(barcode);
                line.isChecked = true;
            }
            return line.barcode === barcode;
        });
        if (!equipment) {
            const newBufferStockItem: DetaillineDTOModel = this.stateManagerService.getCollection(this.collectionsNames.EQUIPMENT)
                .find(line => line.barcode === barcode);
            if (newBufferStockItem) {
                this.confirmAddingItem(newBufferStockItem);
            } else {
                await this.generalService.createToast('Equipment Not Found');
            }
        }
    }

    private async confirmAddingItem(newBufferStockItem: DetaillineDTOModel) {
        const alert = await this.alertController.create({
            header: 'New Item Found!',
            message: 'Do you want add this item to Buffer Stock?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.addItemToBufferStock(newBufferStockItem);
                    }
                }
            ]
        });
        await alert.present();
    }

    private addItemToBufferStock(newBufferStockItem: DetaillineDTOModel) {
        newBufferStockItem = this.findEquipmentPriceService.getChargeLineAndDiscount(newBufferStockItem, this.documentTemp.customer);
        newBufferStockItem.fromDate = new Date().toISOString();
        newBufferStockItem.toDate = new Date().toISOString();
        newBufferStockItem.qty = 1;
        this.documentTemp.detailLines.push(newBufferStockItem);
    }

    loadLiveLinesForWard() {
        // The list is cloned to avoid changing the values in the database
        const tempLines = this.stateManagerService.getCollection(this.collectionsNames.LIVEDETAILLINES)
            .filter(line => line.site === this.documentTemp.site.id && line.stat === 200);
        this.documentTemp.detailLines = JSON.parse(JSON.stringify(tempLines));
        this.scannedTodayService.check(this.documentTemp.detailLines);
        console.log(this.documentTemp.detailLines);
    }

    updateDateFrom() {
        this.documentTemp.detailLines.forEach(line => {
            line.fromDate = new Date().toISOString();
            if (line.isChecked) {
                this.persistScannedBarcodesService.persistBarcode(line.barcode);
                line.toDate = new Date().toISOString();
            }
        });
    }

    saveSaveReconciliation() {
        this.updateDateFrom();
        this.documentTemp.documentNumber = this.documentTemp.detailLines[0].contractDocumentNumber;
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        } else {
            this.generalSaveDocument.generalSaveDocument(this.documentTemp);
        }
    }
}
